function stringToDash(str) {
  return str
    .toLowerCase()                   // Mengubah semua huruf menjadi huruf kecil
    .replace(/\s+/g, '-')       // Menghapus dash di akhir string
}

export default stringToDash